export default __webpack_public_path__ + "static/media/dropboxLogo.ad21f4e2.jpg";